import { IOperationsStatus } from "../../../types/FaceVerification"
import BiometricFaceStream, { RefVideoStream } from "../../VideoStream/BiometricFaceStream"
import VideoGrid from "../../VideoStream/VideoGrid"
import { AppContext } from "../../../store/context"
import { NavigationContext } from "../../../components/Navigation/store/context"
import React, { useContext, useEffect } from "react"
import { setOptionsActive } from "../../../components/Navigation/store/reducer"
import { showMessage } from "../../../store/reducer"
import { IMessage } from "../../../store/actions"

interface IFaceOperation {
    setCheckState: React.Dispatch<React.SetStateAction<IOperationsStatus>>
    childRef: React.RefObject<RefVideoStream>
    setOperationUUID: (uuid: string) => void
    overwriteSuccess?: IMessage
}

const FaceOperation: React.FC<IFaceOperation> = (props) => {

    const dispatch = useContext(AppContext).dispatch;
    const navigationDispatch = useContext(NavigationContext).dispatch

    useEffect(() => {
        let effectRef: RefVideoStream | undefined = undefined
        if (props.childRef.current)
            effectRef = props.childRef.current

        return () => {
            if (effectRef !== undefined && effectRef.cancel)
                effectRef.cancel()
            navigationDispatch(setOptionsActive(true))
            dispatch(showMessage({ message: "", type: "info" }))
        }
    }, [navigationDispatch, dispatch, props.childRef])

    return (
        <VideoGrid item md={10} xs={12}>
            <BiometricFaceStream
                ref={props.childRef}
                setOperationStatus={props.setCheckState}
                setOperationUUID={props.setOperationUUID}
                overwriteSuccess={props.overwriteSuccess}
            />
        </VideoGrid>
    )
}

export default FaceOperation